<template>
  <div class="upload-progress">
    <div class="upload-progress__bar">
      <div class="upload-progress__bar-value" :style="{ width: value + '%' }"></div>
    </div>
    <div class="upload-progress__label">{{ floor }} %</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    floor() {
      return Math.floor(this.value)
    },
  },
}
</script>

<style lang="scss">
.upload-progress {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &__bar {
    flex: 1;
    height: 5px;
    border-radius: 999px;
    background: var(--light-grey);
    overflow: hidden;
  }

  &__bar-value {
    height: 100%;
    background: var(--primary);
    transition: width 100ms ease;
  }

  &__label {
    font-size: 0.75em;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
}
</style>
